import React from 'react';
import { branch } from 'baobab-react/higher-order';
import Helmet from 'react-helmet';
import Breadcrumb from '../common/Breadcrumb';
import BreadcrumbItem from '../common/BreadcrumbItem';
import Header from '../common/Header';
import Tooltip from '../common/Tooltip';
import { Link } from 'react-router';
import { Link as ScrollLink } from 'react-scroll';
import Option from './common/SafeSelectorOption';
import tree from '../../state';
import * as productService from '../../services/productService';

class LockType extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			facet: 'lockType',
			selectedSize: '',
			selectedLockType: '',
			allLockTypes: [],
			btnDisabled: true
		};
	}

	componentDidMount() {
		const query = {
			size: sessionStorage.getItem('selectedSize')
		};
		const data = Object.assign({}, query, '');
		data.minFacetCount = 0;
		productService.productSearch(data).then(result => {
			tree.set('productSearchResults', result);
		});
		this.setState({
			selectedSize: sessionStorage.getItem('selectedSize'),
			selectedLockType: sessionStorage.getItem('selectedLockType'),
			allLockTypes: this.props.facets.filter(item => {
				return item.value === this.state.facet ? item : '';
			})[0].items,
			btnDisabled: sessionStorage.getItem('selectedLockType') === null
		});
	}

	handleChange(e) {
		this.setState({
			selectedLockType: e.target.value,
			btnDisabled: false
		});
	}

	handleSubmit(e) {
		const { selectedLockType, btnDisabled } = this.state;
		if (btnDisabled) {
			e.preventDefault();
		} else {
			sessionStorage.setItem('selectedLockType', selectedLockType);
			global.dataLayer.push({
				event: 'Product Selector',
				eventCategory: 'Product Selector',
				eventAction: 'Continue - Step 3',
				eventLabel: global.location.pathname
			});
		}
	}

	handleSkip() {
		sessionStorage.removeItem('selectedLockType');
		global.dataLayer.push({
			event: 'Product Selector',
			eventCategory: 'Product Selector',
			eventAction: 'Skip - Step 3',
			eventLabel: global.location.pathname
		});
	}

	render() {
		const { facet, selectedLockType, btnDisabled } = this.state;
		const options = this.props.facets.filter(item => {
			return item.value === facet ? item : '';
		})[0].items.map((item, index) => {
			const { name, value, count } = item;
			const obj = {
				id: `lockType${index + 1}`,
				name,
				value,
				count,
				image: '',
				description: ''
			};

			if (name === 'Biometric') {
				obj.image = 'biometric.png';
				obj.description = 'Fingerprint reader unlocks your safe with the swipe of a finger';
			} else if (name === 'Combination') {
				obj.image = 'combination-lock.png';
				obj.description = 'Right-Left-Right dial combination';
			} else if (name === 'Digital') {
				obj.image = 'digital-lock.png';
				obj.description = 'Push-button code entry, choose your own code';
			} else if (name === 'Digital Alarm') {
				obj.image = 'audible-alarm.png';
				obj.description = 'Touchscreen digital keypad with loud tamper/motion alarm';
			} else if (name === 'Flat Key') {
				obj.image = 'privacy-lock.png';
				obj.description = 'Basic privacy protection';
			} else if (name === 'Tubular Key') {
				obj.description = 'Basic privacy protection with improved pick resistance';
				obj.image = 'tubular-key.png';
			}

			return obj;
		});

		const availableLockTypes = options.filter(item => item.count > 0).map((item, index) => {
			const { id, name, value, description, image } = item;

			return (
				<div className="col md-4 mb-4" key={ index }>
					<figure>
						{
							image !== '' ?
								<img
									src={ require(`../../resources/img/callouts/${image}`) }
									alt=""
								/> : ''
						}
					</figure>
					<h3 className="h5">
						{ name }
					</h3>
					{
						description !== '' ?
							<Tooltip
								trigger={ <span className="fa fa-info-circle" aria-hidden="true" /> }
								content={ description }
							/> : ''
					}
					<Option
						className="mt-3"
						id={ id }
						name="safeLockType"
						value={ value }
						checked={ selectedLockType === value }
						onChange={ e => this.handleChange(e) }
						label={ selectedLockType === value ? 'Selected' : 'Select' }
						trackEventAction="Lock Type"
						trackEventLabel={ value }
					/>
				</div>
			);
		});

		const unavailableLockTypes = options.filter(item => item.count === 0).map((item, index) => {
			const { name, value, description, image } = item;

			return (
				<div className="col md-4 mb-4" key={ index }>
					<figure>
						{
							image !== '' ?
								<img
									src={ require(`../../resources/img/callouts/${image}`) }
									alt=""
								/> : ''
						}
					</figure>
					<h3 className="h5">
						{ name }
					</h3>
					{
						description !== '' ?
							<Tooltip
								trigger={ <span className="fa fa-info-circle" aria-hidden="true" /> }
								content={ description }
							/> : ''
					}
					<div className="mt-3">
						<Link
							to={ `/products?lockType=${value}` }
							className="arrow-link"
							data-name={ name }
							onClick={ () => {
								global.dataLayer.push({
									event: 'Product Selector',
									eventCategory: 'Product Selector',
									eventAction: 'View All',
									eventLabel: name
								});
							} }
						>
							View all
						</Link>
					</div>
				</div>
			);
		});

		return (
			<div className="safe-selector">
				<Helmet>
					<title>Safe Selector | SentrySafe</title>
				</Helmet>

				<Breadcrumb>
					<BreadcrumbItem label="Safe Selector" />
				</Breadcrumb>

				<div className="steps-progress">
					<ol>
						<li className="on">
							<Link
								to="/safe-selector/capacity"
								onClick={ e => {
									global.dataLayer.push({
										event: 'Product Selector',
										eventCategory: 'Product Selector',
										eventAction: 'Link',
										eventLabel: e.target.textContent
									});
								} }
							>
								Capacity
							</Link>
						</li>
						<li className="on active">
							<span>Lock Type</span>
						</li>
						<li>
							<span>Protection</span>
						</li>
						<li>
							<span>Results</span>
						</li>
					</ol>
				</div>

				<Header title="Do you have a lock preference?" />

				<span className="arrow-down" />

				<section className="section section-select-safe-lock-type pt-4 pb-5">
					<div className="section-content row text-center">
						<div className="col">
							<div className="select-safe-lock-types" id="available-lock-types">
								<h2 className="assistive-text">Available Lock Types</h2>
								{
									unavailableLockTypes.length === 0 ? '' :
										<p>
											Based on your search, these locks are available. <ScrollLink
												to="unavailable-lock-types"
												spy={ true }
												smooth={ true }
												offset={ 0 }
												duration={ 500 }
												className="text-underline"
												style={{ cursor: 'pointer' }}
											>
												See below
											</ScrollLink> for additional options.
										</p>
								}
								<div className="row">
									{ availableLockTypes }
								</div>
							</div>

							<ul className="list-unstyled m-0 safe-selector-actions">
								<li>
									{
										btnDisabled ?
											<Tooltip
												trigger={
													<Link
														className="btn btn-primary disabled"
														to="#"
														onClick={ e => this.handleSubmit(e) }
													>
														Continue
													</Link>
												}
												content="For the best results, please select an option."
											/>
											:
											<Link
												className="btn btn-primary"
												to="/safe-selector/protection"
												onClick={ e => this.handleSubmit(e) }
											>
												Continue
											</Link>
									}
								</li>
								<li>
									<Link
										to="/safe-selector/capacity"
										onClick={ () => {
											global.dataLayer.push({
												event: 'Product Selector',
												eventCategory: 'Product Selector',
												eventAction: 'Previous - Step 3',
												eventLabel: global.location.pathname
											});
										} }
									>
										Previous
									</Link>
								</li>
								<li>
									<Link
										to="/safe-selector/protection"
										onClick={ () => this.handleSkip() }
									>
										Skip
									</Link>
								</li>
							</ul>

							{
								unavailableLockTypes.length === 0 ? '' :
									<div className="select-safe-lock-types pt-5 mt-5" id="unavailable-lock-types">
										<h2 className="mx-auto">
											The following options are not available based on your current selections.
										</h2>
										<div className="my-3">
											<Link
												className="edit-selections"
												to="/safe-selector/capacity"
												onClick={ () => {
													global.dataLayer.push({
														event: 'Product Selector',
														eventCategory: 'Product Selector',
														eventAction: 'Edit Selections',
														eventLabel: global.location.pathname
													});
												} }
											>
												Edit Selections <span className="fa fa-undo" aria-hidden="true" />
											</Link>
										</div>
										<div className="row">
											{ unavailableLockTypes }
										</div>
									</div>
							}
						</div>
					</div>
				</section>
			</div>
		);
	}
};

export default branch({
	loading: ['loading'],
	facets: ['productSearchResults', 'facets']
}, LockType);


// WEBPACK FOOTER //
// ./src/pages/safeSelector/LockType.js